<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-路线价格-添加
    -->
    <el-dialog
    title="添加路线价格"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加路线价格</div>
    <!-- 全分类选择 -->
    <!-- <el-form-item label="选择全分类" prop="name" >
          <div>{{ form.categorya.name }}</div>
      
        <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为路线价格标题</el-button>
      </el-form-item> -->

      <!-- <el-form-item label="路线价格名称" prop="name"><el-input v-model="form.name" placeholder="请输入路线价格名称" class="max-w460"></el-input></el-form-item> -->
    
      <!-- 儿童年龄 -->
<el-form-item label="儿童年龄" prop="age_child" v-if="showChildAge">
  <el-input
    v-model.number="form.age_child"
    placeholder="0-18岁"
    type="number"
    :min="0"
    :max="18"
    class="max-w460">
    <template #append>岁</template>
  </el-input>
</el-form-item>

<!-- 成人年龄 -->
<el-form-item label="成人年龄" prop="age_adult" v-if="!showChildAge">
  <el-input
    v-model.number="form.age_adult"
    placeholder="18岁以上"
    type="number"
    :min="18"
    :max="120"
    class="max-w460">
    <template #append>岁</template>
  </el-input>
</el-form-item>

<!-- 切换按钮 -->
<div style="margin-bottom: 22px;">
  <el-button 
    @click="showChildAge = true" 
    :type="showChildAge ? 'primary' : 'info'" 
    size="small">
    儿童年龄
  </el-button>
  <el-button 
    @click="showChildAge = false" 
    :type="!showChildAge ? 'primary' : 'info'" 
    size="small">
    成人年龄
  </el-button>
</div>




      <!-- 身高字段 (decimal类型) -->
<el-form-item label="身高" prop="height">
  <el-input 
    v-model.number="form.height"
    placeholder="请输入身高"
    type="number"
    :min="0"
    :step="0.1"
    class="max-w460">
    <template #append>m</template>
  </el-input>
</el-form-item>

      <!-- 价格字段 (decimal类型) -->
      <!-- <el-form-item label="价格">
    <el-input 
      :value="showChildAge ? '60' : '120'"
      placeholder="自动计算"
      readonly
      class="max-w460">
      <template #append>元</template>
    </el-input>
  </el-form-item> -->
  <el-form-item label="价格">
      <el-input 
        :value="currentPrice"
        placeholder="自动计算"
        readonly
        class="max-w460">
        <template #append>元</template>
      </el-input>
    </el-form-item>



  <!-- 路线价格介绍 -->
<el-form-item label="路线价格介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import Route_priceApi from '@/api/route_price.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
    //  Uediter
  },
  data() {
    return {
      showChildAge: true, // 默认显示儿童年龄
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500,
          childAge: null,   // 儿童年龄值
          adultAge: null    // 成人年龄值
        }
      },
      /*form表单数据*/
      form: {
        age_child: null,
        age_adult: null,
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        bannar:[]
      },
      currentPrice: '60',
      loading: false,
      /*验证规则*/
      rules: {
        // name: [{ required: true, message: '请输入路线价格名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  watch: {
    showChildAge(newVal) {
    // 当切换儿童/成人时自动更新价格
    this.currentPrice = newVal ? '60' : '120';
    this.form.price = this.currentPrice; // 同步到表单price字段
  }},
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      this.form.price = this.currentPrice;
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      // if(form.image.length <=0){
      //   self.$message({
      //           message:"请上传图片",
      //           type: 'error'
      //         });
      //         return;
      // }
      // form.categorya = JSON.stringify(form.categorya );
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Route_priceApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
  

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/route_price/index/part/add.vue